import { DataTableColumnDefinition, DataTableRow } from '../DataTableTypes.js';

export const getColumnGroups = <
  TRow extends DataTableRow,
  TColumn extends Pick<DataTableColumnDefinition<TRow>, 'pinned'>
>(
  columns: TColumn[]
) => {
  const columnGroups: [TColumn[], TColumn[], TColumn[]] = [[], [], []];

  columns.forEach((column) => {
    columnGroups[1 + (column.pinned === 'left' ? -1 : column.pinned === 'right' ? 1 : 0)].push(
      column
    );
  });

  return columnGroups;
};
